import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, shape, string } from 'prop-types';
import { Container, Message, StyledLink } from './unsigned-user-state.styles';

const UnsignedUserState = _ref => {
  let {
    message: {
      text: messageText = ''
    } = {},
    loginLink: {
      text: loginLinkText = 'Entre ou cadastre-se',
      url: loginLinkURL = '#'
    } = {},
    handleUnsignedClick
  } = _ref,
      messageStyledProps = _objectWithoutPropertiesLoose(_ref.message, ["text"]),
      loginLinkStyledProps = _objectWithoutPropertiesLoose(_ref.loginLink, ["text", "url"]);

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "stereo-login_menu-unsigned_user_state-container"
  }, messageText && /*#__PURE__*/React.createElement(Message, messageStyledProps, messageText), /*#__PURE__*/React.createElement(StyledLink, _extends({
    onClick: () => {
      handleUnsignedClick();
    },
    href: loginLinkURL
  }, loginLinkStyledProps), loginLinkText));
};

process.env.NODE_ENV !== "production" ? UnsignedUserState.propTypes = {
  message: shape({
    text: string
  }),
  loginLink: shape({
    text: string,
    url: string
  }).isRequired,
  handleUnsignedClick: () => {}
} : void 0;
UnsignedUserState.defaultProps = {
  message: {},
  loginLink: {},
  handleEventClick: func.isRequired
};
export default UnsignedUserState;